import crypto from 'crypto';
import { utils } from 'eciesjs';
import { getClient } from '../services/chainClient';
import store from '../store';

export async function persistBet(
  contractId,
  betDetails?,
  stage = 'OFFER',
  _mnemonic?
) {
  const mnemonic = _mnemonic ?? store.getState().wallet.mnemonic;
  if (!mnemonic) throw new Error('Mnemonic not set');

  const bitcoin = getClient();
  const mnemonicKey = crypto.createHash('sha256').update(mnemonic).digest();
  const existingEncryptedBet = localStorage.getItem(contractId);

  const bet: any = {
    contractId,
    betDetails,
  };

  if (existingEncryptedBet) {
    Object.assign(
      bet,
      JSON.parse(
        utils
          .aesDecrypt(mnemonicKey, Buffer.from(existingEncryptedBet, 'base64'))
          .toString()
      )
    );
  }

  const contract = bitcoin.exportContract(contractId);

  bet.contract = contract;
  bet.stage = stage;

  const betJSON = JSON.stringify(bet);
  const encryptedBet = utils
    .aesEncrypt(mnemonicKey, Buffer.from(betJSON, 'utf8'))
    .toString('base64');

  localStorage.setItem(contract.id, encryptedBet);

  const contractIdListRaw = localStorage.getItem('betIds');

  const contractIdList = contractIdListRaw ? contractIdListRaw.split(',') : [];
  if (!contractIdList?.includes(contract.id)) {
    contractIdList.push(contract.id);
    localStorage.setItem('betIds', contractIdList.toString());
  }
}

export function usePersistBet(_mnemonic) {
  return (contractId, betDetails?, stage = 'OFFER') =>
    persistBet(contractId, betDetails, stage, _mnemonic);
}
